import { render, staticRenderFns } from "./ProductCardTwo.vue?vue&type=template&id=29b19d93&scoped=true&"
import script from "./ProductCardTwo.vue?vue&type=script&lang=js&"
export * from "./ProductCardTwo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardTwo.vue?vue&type=style&index=0&id=29b19d93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b19d93",
  null
  
)

export default component.exports